import React from 'react';
import { useField } from 'formik';
import NumberFormat from 'react-number-format';

export default function WeightField({
  label,
  valueFieldName,
  valuePlaceholder = '00',
  unitFieldName
}) {
  const [unitField] = useField(unitFieldName);
  const [valueField, meta, helpers] = useField(valueFieldName);

  return (
    <div className="form-group form-group-weight">
      <label className="form-label form-label-lg">{label}</label>
      <div className="form-inline unit-field">
        <NumberFormat
          type="text"
          allowNegative={false}
          className="form-control"
          placeholder={valuePlaceholder}
          value={valueField.value}
          onValueChange={val => helpers.setValue(val.floatValue)}
        />
        <span> {unitField.value}</span>
      </div>
      {meta.touched && meta.error && (
        <div className="input-feedback">{meta.error}</div>
      )}
    </div>
  );
}
